import React from 'react';
import '../../../../../less/mobile/index.less';
import { Control } from 'MWC';
import MenuItem from '../../../../../views/menuItem.c';

import abankIcon from "../../../../../img/new/abank-icon.svg"

export default function template() {

    const { active, navigate, activeSub } = this.props;

    return (
        <div className="module-header-mobile__menu">
            <div className="module-header-mobile__menu__content__main">
                <div className="module-header-mobile__menu__content__main__top">
                  <div className="module-header-mobile__menu__content__main__top__input">
                      <input type="text" onClick={() => window.open('/search', '_self')} placeholder={this.l10n('NEW_HEADER_INPUT_PLACEHOLDER')}/>
                  </div>
                  <Control>
                      <MenuItem
                          active={active}
                          alias="cards"
                          navigate={navigate}
                          url="/cards"
                          onClick={() => this.props.changeMenu('cards')}

                      >
                          <div className="module-header-mobile__menu__item" >
                              {this.l10n('HEADER_LINK_CARDS')}
                          </div>
                      </MenuItem>
                      <MenuItem
                          active={active}
                          alias="deposits"
                          navigate={navigate}
                          url="/deposits"
                          onClick={() => this.props.changeMenu('deposits')}
                      >
                          <div className="module-header-mobile__menu__item" >
                              {this.l10n('HEADER_LINK_DEPOSIT')}
                          </div>
                      </MenuItem>
                      <MenuItem
                          active={active}
                          alias="credit"
                          navigate={navigate}
                          url="/credit"
                          onClick={() => this.props.changeMenu('credits')}
                      >
                          <div className="module-header-mobile__menu__item">
                              {this.l10n('HEADER_LINK_CREDIT')}
                          </div>
                      </MenuItem>
                      <MenuItem
                          active={active}
                          alias="business"
                          navigate={navigate}
                          url="/business"
                          onClick={() => this.props.changeMenu('business')}

                      >
                          <div className="module-header-mobile__menu__item" >
                              {this.l10n('HEADER_LINK_BUSINESS')}
                          </div>
                      </MenuItem>
                      <MenuItem
                          active={active}
                          alias="services"
                          navigate={navigate}
                          url="/services"
                          onClick={() => this.props.changeMenu('services')}
                      >
                          <div className="module-header-mobile__menu__item" >
                              {this.l10n('HEADER_LINK_SERVICES')}
                          </div>
                      </MenuItem>


                      <MenuItem
                          active={active}
                          alias="contacts"
                          navigate={navigate}
                          url="/contacts"
                          onClick={this.props.toggle}
                      >
                          <div className="module-header-mobile__menu__item">
                              {this.l10n('HEADER_LINK_CONNACTS')}
                          </div>
                      </MenuItem>
                      <MenuItem
                          className={'title'}
                          active={active}
                          alias="branches"
                          navigate={navigate}
                          url="/branches"
                          onClick={this.props.toggle}
                      >
                          <div className="module-header-mobile__menu__item">
                              {this.l10n('HEADER_LINK_BRANCHES')}
                          </div>
                      </MenuItem>
                  </Control>
                </div>
                <button className="mobile-header-a24" onClick={() => window.open('https://a-bank.com.ua/services/abank', '_blank')}>
                  <div className="mobile-header-a24__image">
                    <img src={abankIcon} alt="abank24-icon" />
                  </div>
                  <div className="mobile-header-a24__text">{this.l10n('NEW_HEADER_ABANK24')}</div>
                </button>
            </div>
        </div>
    );
}
